import { useContext, useEffect, useState, useRef } from 'react'
import { IObject, IResponse } from 'interfaces'
import { useFetch, useStorage } from 'hooks'
import { UserContext } from 'context/userContext'
import {
  Loading,
  ShowDetails,
  DoclistHandle,
  UsersTable,
  Path,
  Toggle,
} from 'components'
import * as Sessions from 'components/Modal/Items'
import { GeneralContext } from 'context/generalContext'
import { hasAccess, moneyToNumber } from 'helper/utils'
import { Container } from './style'
import User from '../Components/User'
import ModalHeader from '../Components/ModalHeader'

export default function DetalhesJuridico() {
  const { selectedId, loading, setLoading } = useContext(UserContext)
  const [data, setData] = useState<any>({})
  const [showDetails, setShowDetails] = useState<boolean>(false)
  const formdata = useRef<FormData>(new FormData())
  const [toggle, setToggle] = useState<string>('current')
  const [previusData, setPreviusData] = useState<any>({})
  const [originalData, setOriginalData] = useState<any>({})
  const [user] = useStorage('User')
  const api = useFetch(`/gestor/contract?id=${selectedId.current}`)

  const fetchData = async (url: string) => {
    try {
      setLoading(true)
      const response: IResponse = await api.fetch('get', null, url)
      if (response.fail) throw new Error(response.errors.message)
      const info = response.data.data
      switch (info?.token?.holderList?.length) {
        case 0:
          info.capType = 'Aberta'
          break
        case 1:
          info.capType = 'Personalizada Individual'
          break
        default:
          info.capType = 'Personalizada em Grupo'
      }
      info.account = await api
        .fetch('get', null, `/gestor/account?id=${info.accountId}`)
        .then((r: IResponse) => r.data.data)

      info.enterprise = await api
        .fetch(
          'get',
          null,
          `/gestor/enterprise?id=${info?.token?.enterpriseId}`
        )
        .then((r: IResponse) => r.data.data)

      info.attachment = { enterprise: [], contract: [] }
      // Enterprise
      ;['contract', 'enterprise'].forEach((s: string) => {
        ;['contract', 'document'].forEach((type: string) => {
          info[s][`${type}List`]?.forEach((c: IObject) => {
            info.attachment[s].push({
              name: c.type,
              file: c.file,
              type,
              status: c.status,
            })
          })
        })
      })
      // console.log(info)
      // setData(info)
      // setOriginalData(info)
      // setLoading(false)
      return info
    } catch (err: any) {
      console.log('err', err)
      setLoading(false)
    }
  }

  // useEffect(() => {
  //   fetchData()
  // }, [])

  useEffect(() => {
    const setInicial = async () => {
      const r = await fetchData(`/gestor/contract?id=${selectedId.current}`)
      setOriginalData(r)
      setData(r)
      setLoading(false)
      if (r.contract?.customData?.sourceId) {
        const p = await fetchData(
          `/gestor/contract?id=${r.contract?.customData?.sourceId}`
        )
        setPreviusData(p)
        setLoading(false)
      }
    }

    setInicial()
    console.log('data no state', data)
  }, [])

  useEffect(() => {
    if (toggle === 'previous') {
      // fetchData(`/gestor/contract?id=${previousId}`)
      setData(previusData)
    } else {
      // fetchData(`/gestor/contract?id=${selectedId.current}`)
      setData(originalData)
    }
  }, [toggle])

  const toggleDisabled = [
    ['Contrato migrado', 'current', true],
    ['Contrato de origem', 'previous', true],
  ]
  const toggleOptionList = [
    ['Contrato migrado', 'current', false],
    ['Contrato de origem', 'previous', false],
  ]
  const invested: any = moneyToNumber(data?.contract?.invested)

  if (loading) return <Loading modal />
  return (
    <Container>
      <Path className="path">
        <span className="path">{'Gestão de clientes > Fluxo jurídico'}</span>
      </Path>
      {originalData?.contract?.customData?.sourceId && (
        <div style={{ width: 280, marginLeft: 5, marginBottom: 20 }}>
          <Toggle
            options={!loading ? toggleOptionList : toggleDisabled}
            toggle={toggle}
            setToggle={setToggle}
          />
        </div>
      )}
      <ModalHeader
        user={data?.account?.user}
        title={data?.token?.name}
        type={data?.capType}
        subtitle="Detalhes da captação"
        status={data?.contract?.status}
        tokenGestorId={data?.token?.gestorId}
        gestorId={data?.account?.account?.gestorId}
      />

      <>
        <ShowDetails
          onClick={() => setShowDetails((oldValue) => !oldValue)}
          hidden={!showDetails}
        />
        {showDetails ? <User accountData={data} /> : null}
      </>

      <Sessions.Info token={data?.token} />
      <Sessions.Condition
        setData={setData}
        contractId={selectedId.current}
        token={data?.token}
        contract={data?.contract}
        enterprise={data?.enterprise}
      />
      <Sessions.Contract token={data?.token} contract={data?.contract} />
      <Sessions.Rental token={data?.token} />
      <Sessions.Dates
        isInvesment={invested > 0}
        token={data?.token}
        data={data}
      />
      {data?.bonus && <Sessions.Bonus data={data?.bonus} />}
      <Sessions.Payments token={data?.token} contract={data?.contract} />
      <Sessions.Simula
        id={data?.token?.id}
        name={data?.enterprise?.name}
        value={data?.token?.expected}
        isInsento={data?.token?.IRType === 'Isento'}
      />
      {data?.token?.holderList?.length > 1 && (
        <UsersTable
          captationID="id"
          data={data?.token?.holderList}
          disableDelete
        />
      )}
      <h4 className="detalhes-captacao-subtitle">Anexos da propostas</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          readonly={
            data?.contract?.status === 'Contrato Assinado' ||
            !hasAccess('detalhe-juridico-add-documents')
          }
          documentList={data?.attachment?.contract}
          formdata={formdata.current}
          onChange={() => {
            api
              .fetch(
                'put',
                formdata.current,
                `/gestor/contract?id=${selectedId?.current}`,
                { 'Content-type': 'multipart/form-data' }
              )
              .then(console.log)
          }}
        />
      </div>
      <h4 className="detalhes-captacao-subtitle">Anexos do empreendimento</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          documentList={data?.attachment?.enterprise}
          readonly
          formdata={formdata.current}
          onChange={() => {
            api
              .fetch(
                'put',
                formdata.current,
                `/gestor/contract?id=${selectedId.current}`,
                { 'Content-type': 'multipart/form-data' }
              )
              .then(console.log)
          }}
        />
      </div>
    </Container>
  )
}
